import React from "react";
import NavBar from "./component/Navbar/Navbar"; // adjust the path as needed
import FooterSection from "./component/footer/footer"; // adjust the path as needed
import DigitalLendingPartners from "./component/mainSection/mainsection";// adjust the path as needed

const PartnersPage = () => {
  return (
    <div className="flex relative  flex-col bg-[#FBF8F3] z-0">
      <img src="/assets/img/bgGrid.png" className="absolute top-0 left-0  h-auto w-auto sm:h-full sm:w-full   -z-10"/>
      {/* Header */}
     <NavBar/>

      {/* Main Content */}
      <main className="flex-grow w-full max-w-7xl mx-auto">
        <DigitalLendingPartners />
      </main>

      {/* Footer */}
     <FooterSection/>
    </div>
  );
};

export default PartnersPage;
